<template>

    <div class="px-2 px-lg-3 py-2 w-100" :class="getEventStatusClass()">
        <!-- listing block -->
        <div>
            <div class="position-relative">
                <!-- Event Status Badge -->
                <div v-if="showEventStatusBadge()" class="event-status-badge position-absolute top-0 start-0 z-3">
                    <span class="badge" :class="getEventStatusBadgeClass()">
                        <i :class="getEventStatusIcon()" class="me-1"></i>
                        {{ getEventStatusText() }}
                    </span>
                </div>

                <div class="card-top d-flex justify-content-between align-items-center py-1 rounded-3 rounded-bs-0 rounded-be-0">
                    <!-- repetitive events who Upcoming top-left -->
                    <span class="badge text-white">
                        {{ changeDateFormat(userTimezone(event.start_date+' '+event.start_time, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'), "YYYY-MM-DD") }}
                    </span>

                    <!-- Repetitive info bottom left -->
                     <!-- event ended -->
                    <span class="d-inline-flex badge bg-danger" 
                        v-if="!event.repetitive && moment().format('YYYY-MM-DD') > userTimezone(event.end_date+' '+event.end_time, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')">
                        <i class="fas fa-ban"></i> &nbsp;{{ trans('em.ended') }}
                    </span>
                    <span class="d-inline-flex badge bg-danger" 
                        v-else-if="event.repetitive && moment().format('YYYY-MM-DD') > userTimezone(event.end_date+' '+event.end_time, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')" >
                        <i class="fas fa-ban"></i> &nbsp;{{ trans('em.ended') }}
                    </span>
                    <span v-else-if="event.repetitive" class="d-inline-flex badge"><i class="fas fa-repeat"></i> &nbsp;
                        <span v-if="event.repetitive_type == 1">{{ trans('em.daily') }}</span>
                        <span v-else-if="event.repetitive_type == 2">{{ trans('em.weekly') }}</span>
                        <span v-else-if="event.repetitive_type == 3">{{ trans('em.monthly') }}</span>
                    </span>
                </div>

                <a  :href="eventSlug(event.slug)" class="text-inherit">
                    <div class="thumb-img-bg rounded-3 prevent_draggable rounded-ts-0 rounded-te-0" 
                         :style="{ 'background-image': `url(${getImageUrl(event.thumbnail)})`}" >
                        <img class="thumb-img prevent_draggable" :src="getImageUrl(event.thumbnail)" :alt="event.title" />
                    </div>
                </a>
                
                <!-- Seasonal info bottom right -->
                <span v-if="event.merge_schedule" class="d-inline-flex badge font-size-p7 bg-secondary position-absolute bottom-0 mb-5 end-0 rounded-be-0 rounded-te-0 "><i class="fas fa-stopwatch-20"></i> &nbsp;{{ trans('em.seasonal_tickets') }}</span>
                <span v-if="event.featured > 0" class="d-inline-flex badge font-size-p7 bg-success position-absolute bottom-0 mb-2 end-0  rounded-be-0 rounded-te-0 "><i class="fas fa-medal"></i> {{ trans('em.featured') }}</span>
                
            </div>
            <div class="rounded-bottom border-0 mb-lg-0">
                <div class="d-flex justify-content-between">
                    <div class="card-category text-gray-700">
                        <small>{{ event.category_name }}</small>
                    </div>  
                </div>
                
                <div>
                    <h6 class="text-left p-0 m-0 fw-bold lh-p2">
                        <a  :href="eventSlug(event.slug)" class="text-inherit">
                        {{ event.title.substring(0, 76) }} 
                        </a>
                    </h6>
                </div>
                
                <div class="card-venue">
                    <span v-if="event.venues.length > 0"><i class="fas fa-map-marker-alt"></i>&nbsp;{{event.venues[0].title}},&nbsp;{{event.venues[0].city}}</span>
                    &nbsp;<span v-if="event.online_location" class="text-success"><i class="fas fa-circle-play"></i> &nbsp;{{ trans('em.online_event') }}</span>
                </div>
                
                <hr class="card-hr">
                <div class="d-flex justify-content-between" v-if="event.tickets.length > 0">
                    <span class="h6 lh-p2 fw-semibold">A partir de {{`${currency} ${event.tickets[0].price}`  }}</span>
                </div>    

                <div class="d-grid mt-2">
                    <a :href="eventCheckoutUrl(event.slug)" class="btn btn-primary btn-sm fw-semibold">
                        INSCREVA-SE
                    </a>
                </div>
                
            </div>
        </div>
        <!-- listing block -->
    </div>
           
   
</template>

<script>

import mixinsFilters from '../mixins.js';

export default {
    
    props: ['event', 'currency', 'date_format'],


    mixins:[
        mixinsFilters
    ],

    data() {
        return {
        }
    },

    methods:{
        
        // check free tickets of events
        checkFreeTickets(event_tickets = []){
            let free = false;
            event_tickets.forEach(function(value, key) {
                if(parseFloat(value.price) <= parseFloat(0))
                {
                    free = true;
                }
            });    
            return free;
        },

        
        // return route with event slug
        eventSlug: function eventSlug(slug) {
            return route('eventmie.events_show', [slug]);
        },

        eventCheckoutUrl(slug) {
            return this.eventSlug(slug) + '#/checkout';
        },

        // Event Status Methods
        showEventStatusBadge() {
            return this.event && this.event.event_status && 
                   ['courtesy_mode', 'marketing_mode', 'inactive_mode'].includes(this.event.event_status);
        },

        getEventStatusClass() {
            if (!this.event || !this.event.event_status) return '';
            
            const classes = {
                'courtesy_mode': 'event-courtesy-mode',
                'marketing_mode': 'event-marketing-mode',
                'inactive_mode': 'event-inactive-mode'
            };
            
            return classes[this.event.event_status] || '';
        },

        getEventStatusBadgeClass() {
            const classes = {
                'courtesy_mode': 'bg-warning text-dark',
                'marketing_mode': 'bg-info text-white',
                'inactive_mode': 'bg-secondary text-white'
            };
            
            return classes[this.event.event_status] || 'bg-info text-white';
        },

        getEventStatusIcon() {
            const icons = {
                'courtesy_mode': 'fas fa-gift',
                'marketing_mode': 'fas fa-bullhorn',
                'inactive_mode': 'fas fa-pause'
            };
            
            return icons[this.event.event_status] || 'fas fa-info-circle';
        },

        getEventStatusText() {
            const texts = {
                'courtesy_mode': 'Cortesia',
                'marketing_mode': 'Marketing',
                'inactive_mode': 'Inativo'
            };
            
            return texts[this.event.event_status] || '';
        }

  
    },

    mounted(){      
    }

}
</script>

<style scoped>
/* Event Status Styles */
.event-status-badge {
    margin: 8px;
    z-index: 10;
}

.event-status-badge .badge {
    font-size: 0.75rem;
    padding: 0.4rem 0.6rem;
    border-radius: 6px;
    font-weight: 600;
}

/* Courtesy Mode */
.event-courtesy-mode {
    border: 2px solid #ffc107;
    border-radius: 12px;
    background: linear-gradient(135deg, rgba(255, 193, 7, 0.05) 0%, rgba(255, 255, 255, 0.05) 100%);
    box-shadow: 0 2px 8px rgba(255, 193, 7, 0.2);
}

.event-courtesy-mode:hover {
    box-shadow: 0 4px 16px rgba(255, 193, 7, 0.3);
    transform: translateY(-2px);
    transition: all 0.3s ease;
}

/* Marketing Mode */
.event-marketing-mode {
    border: 2px solid #17a2b8;
    border-radius: 12px;
    background: linear-gradient(135deg, rgba(23, 162, 184, 0.05) 0%, rgba(255, 255, 255, 0.05) 100%);
    box-shadow: 0 2px 8px rgba(23, 162, 184, 0.2);
}

.event-marketing-mode:hover {
    box-shadow: 0 4px 16px rgba(23, 162, 184, 0.3);
    transform: translateY(-2px);
    transition: all 0.3s ease;
}

/* Inactive Mode */
.event-inactive-mode {
    filter: grayscale(80%);
    opacity: 0.7;
    border: 2px solid #6c757d;
    border-radius: 12px;
    background: linear-gradient(135deg, rgba(108, 117, 125, 0.05) 0%, rgba(255, 255, 255, 0.05) 100%);
}

.event-inactive-mode:hover {
    filter: grayscale(60%);
    opacity: 0.8;
    transition: all 0.3s ease;
}

.event-inactive-mode .thumb-img-bg,
.event-inactive-mode .thumb-img {
    filter: grayscale(100%);
}

.event-inactive-mode h6,
.event-inactive-mode .card-category,
.event-inactive-mode .card-venue {
    color: #6c757d !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .event-status-badge {
        margin: 4px;
    }
    
    .event-status-badge .badge {
        font-size: 0.65rem;
        padding: 0.3rem 0.5rem;
    }
}
</style>